import {
  ToggleBlockType
} from './block-type'

export class HeaderFive extends ToggleBlockType {
  getBlockType = () => 'header-five'

  getButtonText = () => 'H5'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/block-type/header-five.js
 **/